<div class="container-head">
  <span class="noOfRestoList">{{lengthCusines}} Cuisines</span>
  <span class="resto-input">
    <div style="padding: 2px">
      <img src="../../../assets/images/Search.png" alt="" />
      <input
        placeholder="Cuisines name"
        [(ngModel)]="searchText"
        (ngModelChange)="filter()"
      />
    </div>
  </span>
  <div class="addRestoBtn" (click)="addCuisines()">
    <div>
      <img src="../../../assets/images/Plus.png" alt="" />
      <span>Add cuisines</span>
    </div>
  </div>
</div>
<table mat-table [dataSource]="dietaryData" class="mat-elevation-z8 demo-table">
  <!-- Position Column -->
  <ng-container matColumnDef="SL-NO">
    <th mat-header-cell *matHeaderCellDef class="table-head checking">
      S.I<br />No.
    </th>
    <td mat-cell *matCellDef="let element;let i = index" class="table-element">
      {{i+1}}
    </td>
  </ng-container>
  <ng-container matColumnDef="icon">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="table-head checking cuisines-icon"
    >
      Cuisines Image
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      class="table-element cuisines-icon-element"
    >
      <img [src]="element.image" alt="" style="max-width: 90px;" onContextMenu="return false;" >
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef class="table-head checking">
      Cuisines Name
    </th>
    <td mat-cell *matCellDef="let element" class="table-element">
      {{ element.cuisine_name }}
    </td>
  </ng-container>
  <!-- Weight Column -->
  <ng-container matColumnDef="edit">
    <th mat-header-cell *matHeaderCellDef class="table-head checking">Edit</th>
    <td mat-cell *matCellDef="let element" class="table-element">
      <img
        src="../../../assets/images/editIcon.png"
        alt=""
        class="edit-element"
        (click)="editDialog(element.cuisine_id)"
      />
    </td>
  </ng-container>

  <!-- Symbol Column -->

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef class="table-head action-th checking">
      Action
    </th>
    <td mat-cell *matCellDef="let element" class="table-element action-element">
      <img
        src="../../../assets/images/deletIcon.png"
        alt=""
        (click)="openDialog(element.cuisine_id)"
      />
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<mat-paginator #paginator2 [pageSizeOptions]="[12,20,25]"></mat-paginator>

<style>
  .allergens-head {
    display: flex;
    margin: 50px 0;
  }

  .allergensBtn {
    display: flex;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    color: rgba(57, 64, 70, 1);
    width: 214px;
    height: 43px;
    justify-content: center;
    align-items: center;
    background-color: rgba(238, 238, 238, 1);
    border-radius: 6px;
    cursor: pointer;
  }
  .allergensBtn:hover {
    box-shadow: 0px 2px 4px rgba(3, 3, 3, 0.25);
  }
  .dietaryBtn {
    margin-left: 6%;
  }
  .bgSelectClass {
    background-color: rgba(81, 172, 96, 1);
    color: rgba(255, 255, 255, 1);
  }

  .noOfRestoList {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }

  .addRestoBtn {
    display: inline-block;
    border-radius: 6px;
    background: linear-gradient(90.17deg, #2fb9e3 -97.61%, #56ab51 120.65%);
    float: right;
    width: 19vw;
    cursor: pointer;
  }

  .addRestoBtn img {
    margin: 0 2.4vw;
  }

  .addRestoBtn span {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 40px;
    color: rgba(255, 255, 255, 1);
  }

  .addRestoBtn:hover {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  }

  .demo-table {
    width: 100%;
  }

  .mat-column-demo-position {
    width: 32px;
    padding-right: 24px;
    text-align: center;
  }

  .mat-elevation-z8 {
    box-shadow: 0px 0px;
    padding: 10px 0px;
    margin-bottom: 20px;
  }

  .mat-column-demo-name {
    padding-left: 16px;
    font-size: 20px;
  }

  .mat-column-demo-weight {
    font-style: italic;
  }

  .mat-column-demo-symbol {
    width: 32px;
    text-align: center;
    font-weight: bold;
  }

  .containerResto {
    margin-right: 15px;
    background-color: rgba(255, 255, 255, 1);
    height: 60vh;
    border-radius: 30px;
    border-radius: 20px;
  }

  .container-head {
    padding: 20px;
  }

  .resto-input {
    display: inline-flex;
    border: 1px solid rgba(161, 167, 171, 1);
    border-radius: 8px;
    margin: 0px 28px;
  }

  .resto-input img {
    padding: 5px;
  }

  .resto-input input {
    border: 0px solid;
    padding: 10px;
  }

  .resto-input input:focus {
    outline-width: 0;
  }

  .table-head {
    font-family: "Helvetica";
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 25px;
    color: rgba(57, 64, 70, 1);
  }

  .table-element {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: rgba(106, 112, 118, 1);
  }
  .cuisines-icon {
    padding-left: 2%;
  }
  .cuisines-icon-element {
    padding-left: 2%;
  }
  .edit-element {
    margin-left: 3%;
    cursor: pointer;
  }

  .action-th {
    padding: 0 10%;
  }

  .action-element {
    padding-left: 11.5%;
    cursor: pointer;
  }

  .status-element {
    color: red;
  }

  .active {
    color: green;
  }

  .checking {
    background-color: rgba(238, 238, 238, 1);
  }

  :host ::ng-deep tr.mat-row,
  tr.mat-footer-row {
    height: 70px;
  }

  :host ::ng-deep .mat-paginator-container {
    justify-content: space-between;
  }
</style>
